// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nUwU","content":"styles_content__2dkca"};